import MuiBox from '@material-ui/core/Box';

export default MuiBox;
